var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('devlog-header'),_vm._l((Object.keys(_vm.postsData)),function(key){return _c('div',{key:key},[_c('post-preview',{staticStyle:{"margin-left":"auto","margin-right":"auto"},attrs:{"post":_vm.postsData[key],"file":key}}),_c('div',{staticStyle:{"height":"50px"}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }